import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm'
import { ProgPricePriceBasis } from './formFields/ProgPricePriceBasis'
import { useEffect, useState } from 'react';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { DateUtils } from '@/common/utils/DateUtils';
import { ProgPriceValue } from './formFields/ProgPriceValue';
import { endDateValidator, startDateValidator } from '@/common/form/validators/dateValidators';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';

export const ProgPriceForm = () => {
  const { entityObj } = useEntityMgr();
  const rsrc = useRsrc();
  const [progObj, setProgObj] = useState(null);

  // Contract object is important for validations //TODO: TEST creation from parent entity
  useEffect(() => {
    const progId = entityObj?.progId; 
    rsrc.byId('md', 'PROG', progId).then(res => setProgObj(res));
  }, []);

  if (!progObj) return <></>; 
  
  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.priceBasis.component = <ProgPricePriceBasis fieldDef={fieldToFieldDef.priceBasis}/>
    fieldToFieldDef.value.component = <ProgPriceValue fieldDef={fieldToFieldDef.value}/>

    fieldToFieldDef.startDate.validators = [
      (value) => {
        return value >= progObj.startDate ? null : `Start date must be on or after Contract start date (${DateUtils.format(progObj.startDate)})`
      },
      startDateValidator
    ];
  
    fieldToFieldDef.endDate.validators = [
      (value) => {
        return value <= progObj.endDate ? null : `End date must be on or before the Contract end date (${DateUtils.format(progObj.endDate)})`
      }, 
      endDateValidator
    ]
  }

  return (
    <EntityForm augFieldDefs={augFieldDefs}/>
  )
}